import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const ChatbotQuestionAnswerRecords = loadable(() => import('./List'), {
  fallback: <FullPageLoader />,
});

